import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';

import { HttpErrorResponse } from '@angular/common/http';
import { EDI271BO } from '../eligibility-logs/eligibility-logs-model';
import { CommonApiService } from 'src/app/service/commonapiservice';
import { GetEDI271ClientBO } from '../client-parent/client-parent.model';
import { GeneralService } from 'src/app/service/general.service';

@Component({
  selector: 'app-eligibility-details',
  templateUrl: './eligibility-details.component.html',
  styleUrls: ['./eligibility-details.component.scss']
})
export class EligibilityDetailsComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() Id;
  viewFiles271: boolean = false;
  edi271list: EDI271BO[] = [];;
  @Output() Event = new EventEmitter<GetEDI271ClientBO>();
  constructor(public datepipe: DatePipe, public global: GlobalComponent,
    public CommonAPI: CommonApiService, public general: GeneralService,  public router: Router, public toastrService: ToastrService, private ref: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.viewlasteb(this.Id);
  }
  viewlasteb(id) {
    let myparams = new URLSearchParams();
    myparams.append("id", id);
    let url = "api/Claims/GetClients271Detail?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.edi271list = data;
      this.viewFiles271 = true;
    },
        (err: HttpErrorResponse) => {
        this.toastrService.error(err?.error, 'error')
      }
    );
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
